<template>
  <div class="listMenu" :style="style">
    <div class="listMenu__menu" v-for="menu in menuList">
      <div v-if="menu.title || menu.icon"
        class="listMenu__menu__head"
        :class="{'listMenu__menu__head--single' : !menu.children || menu.children.length === 0}"
      >
        <icon-base class="listMenu__menu__icon"
          v-if="menu.iconComponent"
          :name="menu.iconComponent"
          :color="headColor ? headColor : fontColor"
        />
        <img class="listMenu__menu__icon" v-if="menu.iconSrc" :src="menu.iconSrc" />
        <span v-if="!menu.url">{{ menu.title }}</span>
        <a v-else
          :href="menu.url"
          :target="menu.tgtBlank ? '_blank' : ''"
          @click.prevent="checkModalState($event, true)"
          >{{ menu.title }}
        </a>
      </div>
      <ul>
        <li class="listMenu__menu__list" v-for="child in menu.children" ontouchstart="">
          <a
            :href="child.url"
            :target="child.tgtBlank ? '_blank' : ''"
            v-html="child.title"
            :class="{linkDisabled :child.isDisabled}"
            @click.prevent="checkModalState($event, true)"
          />
        </li>
      </ul>
    </div>
    <div class="line-campaign-banner" v-if="hasLineCampaignBanner">
      <block-banner banner-pos="nologin-hamburger-bottom" :ga-event-categ="`Nav-LINE-campaign-banner`"/>
    </div>
  </div>
</template>

<script>
import IconBase from './icon/IconBase'
import * as type from '@/utvStore/store/mutation-types'
import BlockBanner from '@/utvStore/components/recommend/lp/blocks/BlockBanner'

export default {
  name: 'listMenu',
  components:{
    IconBase,
    BlockBanner,
  },
  data() {
    return {
    }
  },
  props: {
    menuList: {
      type: Array,
      default: () => []
    },
    fontColor: {
      type: String,
      default:'white'
    },
    padding: {
      type: String,
      default:'0'
    },
    iconColor: {
      type: String,
      default:''
    },
    headColor: {
      type: String,
      default:''
    },
    hoverColor: {
      type: String,
      default: ''
    },
    hasLineCampaignBanner: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    style() {
      return {
        '--font-color': this.fontColor,
        '--head-color': !!this.headColor && this.headColor.length > 0 ? this.headColor : this.fontColor,
        '--hover-color': !!this.hoverColor && this.hoverColor.length > 0 ? this.hoverColor : 'linear-gradient(59.75deg, #FFF3F5 21.4%, #F9F4FD 76.64%)',
        '--padding':this.padding
      }
    }
  },
  methods: {
    checkModalState(e, isClose, title, menu){
      //カテゴリ系ページへのリンクの場合キャッシュ削除
      if(  /\/category\/\w+/.test(e.target.href)
        || /\/history\/later/.test(e.target.href)
      ) {
        this.$store.dispatch(type.SET_CATPAGE_REFERRER, '')
      }
      if(isClose){
        //const.jsのcloseModal=trueのメニューの場合だけ閉じるようにしていたが仕様変更により遷移時には常に閉じるように変更
        setTimeout(() => {
          this.$store.dispatch(type.ACCOUNT_MODAL_VISIBILITY, false)
          this.$store.dispatch(type.DRAWER_MENU_VISIBILITY, false)
          this.$store.dispatch(type.FOOTER_MENU_VISIBILITY, false)
          }, 500)
      }
      if(!!e.target.href && e.target.href.length > 0 ) {
        if (e.target.target === '_blank') window.open(e.target.href, '_blank')
        else location.href = e.target.href
      }
      return false
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

$l_col_font: var(--font-color);
$l_col_head: var(--head-color);
$l_col_hover: var(--hover-color);

.listMenu{
  padding: var(--padding);
  &__menu{
    color: $l_col_font;
    padding: 0;
    margin-top: 0;

    &__head{
      font-weight: bold;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      color: var(--head-color);

      &--single{
        margin-bottom: 20px;
      }

      a{
        color: var(--head-color);
      }
    }

    &__icon{
      margin-right: 20px;
    }

    &__list{
      line-height: 35px;
      padding: 0 20px 0 60px;
      margin: 0 -20px 10px;
      &:last-child{
        margin-bottom: 20px;
      }
      &:hover,&:active{
        background: $l_col_hover;
      }
      .linkDisabled{
        pointer-events: none;
      }
      a{
        line-height: 35px;
        display: block;
        /deep/ .disabledLink {
          color: $col_temp_gray5;
          .info{
            display: block;
            color: $col_temp_key1;
            font-size: 10px;
            line-height:1px
          }
        }
      }
    }
  }
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
a{
  text-decoration: none;
  color: $l_col_font;
}
.line-campaign-banner {
  /deep/ .block-banner {
    padding: 0 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/ListMenu.vue